/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UsageFeeBillsInner } from './usage-fee-bills-inner';
// May contain unused imports in some cases
// @ts-ignore
import { UsageFeeLatestStatus } from './usage-fee-latest-status';

/**
 * 
 * @export
 * @interface UsageFee
 */
export interface UsageFee {
    /**
     * 
     * @type {string}
     * @memberof UsageFee
     */
    'usageFeeId': string;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'yearMonth': number;
    /**
     * 
     * @type {string}
     * @memberof UsageFee
     */
    'scheduledPaymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof UsageFee
     */
    'paymentDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof UsageFee
     */
    'paymentType': UsageFeePaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'pointAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'billsNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'unitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'transferAgencyFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'discountQuota': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'discountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'discountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'discountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardsNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardUsageFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardDiscountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardDiscountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'cardDiscountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardsNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardUsageFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardDiscountedNum': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardDiscountUnitPrice': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'virtualCardDiscountedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'subTotal': number;
    /**
     * 
     * @type {number}
     * @memberof UsageFee
     */
    'salesTaxAmount': number;
    /**
     * 
     * @type {UsageFeeLatestStatus}
     * @memberof UsageFee
     */
    'latestStatus': UsageFeeLatestStatus;
    /**
     * 
     * @type {Array<UsageFeeBillsInner>}
     * @memberof UsageFee
     */
    'bills': Array<UsageFeeBillsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof UsageFee
     */
    'isCardUsageFeeWaived': boolean;
}

export const UsageFeePaymentTypeEnum = {
    payBill: 'PAY_BILL',
    usageFee: 'USAGE_FEE',
    card: 'CARD',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type UsageFeePaymentTypeEnum = typeof UsageFeePaymentTypeEnum[keyof typeof UsageFeePaymentTypeEnum];


